"use strict";
var Trending = (function () {
    function Trending() {
    }
    return Trending;
}());
exports.Trending = Trending;
//# sourceMappingURL=Trending.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/Trending.js
 ** module id = 345
 ** module chunks = 0
 **/